import { z } from "zod";

export const BookingExtrasForm = z.object({
  amenitiesDetails: z.array(
    z.object({
      id: z.string(),
      paidLocally: z.boolean(),
      price: z.number(),
      text: z.string(),
      obligatory: z.boolean(),
      checked: z.boolean(),
      currency: z.string().optional(),
      currencyId: z.string().optional(),
      hidden: z.boolean().optional(),
      freeOfCharge: z.boolean().optional(),
      number: z.number().optional().nullable(),
      provider: z.enum(["NS", "CYA", "BM", "Helm", "Yachtfolio"]).optional(),
      isCustomAmenity: z.boolean().optional(),
      formula: z.string().optional(),
    }),
  ),
});

export type BookingExtrasForm = z.infer<typeof BookingExtrasForm>;

export const emptyBookingExtras: BookingExtrasForm = {
  amenitiesDetails: [],
};
